import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from '../../../shared/gtp';
import { Constant, VersionChange } from '../../../shared/constant';

@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.scss']
})
export class UpgradeComponent implements OnInit {
  versions: VersionChange[] = [];
  visibleVersions: number = 3; // Número inicial de versiones a mostrar
  currentVersion: string = '';

  constructor(
    private router: Router,
    public gtp: Gtp,
    private constant: Constant
  ) {}

  ngOnInit(): void {
    this.initializeVersions();
  }

  initializeVersions(): void {
    // Obtener versiones desde el servicio centralizado
    this.versions = this.constant.versionesCompletas;
    this.currentVersion = this.constant.version;
  }

  loadMoreVersions(): void {
    // Incrementar el número de versiones visibles
    this.visibleVersions += 3;

    // Limitar al número máximo de versiones disponibles
    if (this.visibleVersions > this.versions.length) {
      this.visibleVersions = this.versions.length;
    }
  }

  closeMovil(): void {
    this.router.navigate(['/inicio/flota'])
  }

  volver(): void {
    this.gtp.setAdminSidebar(true);
  }
}
